/* Khakma — Nuxio görünümü için küçük yardımcılar (sekme, slider okları, geri sayım, buton daire efekti) */
(function () {
  'use strict';

  /* Slider okları: scroll-snap track'i bir kart genişliği kaydır; uçlarda disable */
  function initSlider(root) {
    var track = root.querySelector('.kh-slider__track');
    if (!track) return;
    var prev = root.querySelector('[data-kh-prev]');
    var next = root.querySelector('[data-kh-next]');
    function step() {
      var s = track.querySelector('.kh-slider__slide');
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return s ? s.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    root.addEventListener('kh:refresh', function () { requestAnimationFrame(update); });   /* gizliyken ölçülemez: mega açılınca yeniden */
    update();
  }

  /* Sekmeler (WAI-ARIA tablist) */
  function initTabs(root) {
    var btns = root.querySelectorAll('.kh-tabs__btn');
    var panels = root.querySelectorAll('.kh-tabs__panel');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
        panels.forEach(function (p) { p.hidden = true; });
        b.setAttribute('aria-selected', 'true');
        var p = root.querySelector('#' + b.getAttribute('aria-controls'));
        if (p) { p.hidden = false; p.querySelectorAll('.kh-slider').forEach(function (s) { s.dispatchEvent(new Event('kh:refresh')); }); }
      });
    });
  }

  /* Geri sayım: data-end="2026-09-30T23:59:59+03:00" */
  function initCountdown(el) {
    var end = new Date(el.getAttribute('data-end')).getTime();
    if (isNaN(end)) return;
    var f = { d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') };
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var diff = Math.max(0, end - Date.now());
      if (diff === 0) { el.classList.add('is-elapsed'); return; }
      var d = Math.floor(diff / 864e5), h = Math.floor(diff % 864e5 / 36e5), m = Math.floor(diff % 36e5 / 6e4), s = Math.floor(diff % 6e4 / 1e3);
      if (f.d) f.d.textContent = pad(d);
      if (f.h) f.h.textContent = pad(h);
      if (f.m) f.m.textContent = pad(m);
      if (f.s) f.s.textContent = pad(s);
      setTimeout(tick, 1000);
    }
    tick();
  }

  /* Buton daire efekti: dairenin merkezi imlecin girdiği nokta (hdt-circle-bg) */
  function initCircle(btn) {
    btn.addEventListener('pointerenter', function (e) {
      var r = btn.getBoundingClientRect();
      btn.style.setProperty('--kh-x', ((e.clientX - r.left) / r.width * 100) + '%');
      btn.style.setProperty('--kh-y', ((e.clientY - r.top) / r.height * 100) + '%');
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('.kh-slider').forEach(initSlider);
    scope.querySelectorAll('.kh-tabs').forEach(initTabs);
    scope.querySelectorAll('.kh-countdown[data-end]').forEach(initCountdown);
    scope.querySelectorAll('.kh-btn').forEach(initCircle);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  /* Tema düzenleyici bölümü yeniden çizince */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Nuxio: mega menü hover ile açılır (Dawn details), mobil alt çubuk Dawn çekmecelerini tetikler */
(function () {
  'use strict';
  var mq = window.matchMedia('(min-width: 990px)');
  var timer;
  document.querySelectorAll('header-menu > details.mega-menu').forEach(function (d) {
    var host = d.parentElement;
    host.addEventListener('mouseenter', function () { if (!mq.matches) return; clearTimeout(timer); document.querySelectorAll('header-menu > details.mega-menu[open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); }); d.setAttribute('open', ''); d.querySelectorAll('.kh-slider').forEach(function (s) { s.dispatchEvent(new Event('kh:refresh')); }); });
    host.addEventListener('mouseleave', function () { if (!mq.matches) return; timer = setTimeout(function () { d.removeAttribute('open'); }, 120); });
    /* Nook: masaüstünde ana başlık tıklanınca kategoriye gider (menüyü hover açar); klavyede (detail 0) Dawn davranışı kalır */
    var sum = d.querySelector(':scope > summary[data-kh-href]');
    if (sum) sum.addEventListener('click', function (e) {
      if (!mq.matches || e.detail === 0) return;
      e.preventDefault(); e.stopImmediatePropagation();
      window.location.href = sum.getAttribute('data-kh-href');
    }, true);
  });
  var nav = document.querySelector('[data-kh-navbar]');
  if (!nav) return;
  var openMenu = nav.querySelector('[data-kh-open-menu]'), openSearch = nav.querySelector('[data-kh-open-search]'), openCart = nav.querySelector('[data-kh-open-cart]');
  if (openMenu) openMenu.addEventListener('click', function () {
    var d = document.getElementById('Details-menu-drawer-container');
    if (d) { d.open = !d.open; var s = d.querySelector('summary'); if (s) s.setAttribute('aria-expanded', d.open ? 'true' : 'false'); document.body.classList.toggle('overflow-hidden-mobile', d.open); }
  });
  if (openSearch) openSearch.addEventListener('click', function () {
    var dm = document.querySelector('.header__search details-modal');
    var d = dm ? dm.querySelector('details') : null;
    if (d) { d.open = true; var i = d.querySelector('input[type="search"]'); if (i) setTimeout(function () { i.focus(); }, 50); }
    else window.location.href = '/search';
  });
  if (openCart) openCart.addEventListener('click', function (e) {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.open === 'function') { e.preventDefault(); cd.open(); }
  });
  document.addEventListener('cart:refresh', function () {});
  /* sepet sayacı: Dawn'ın cart-icon-bubble'ını izle */
  var obs = new MutationObserver(function () {
    var b = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
    var c = nav.querySelector('[data-kh-cart-count]');
    if (c) { var n = b ? parseInt(b.textContent, 10) || 0 : 0; c.textContent = n; c.classList.toggle('is-visible', n > 0); }
  });
  var bubble = document.getElementById('cart-icon-bubble');
  if (bubble) obs.observe(bubble, { childList: true, subtree: true, characterData: true });
})();

/* 09-18 Nook header: duyuru döndürücü · mobil çekmece akordeonu + kapat */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRotator(root) {
    if (root.dataset.khInit) return; root.dataset.khInit = '1';
    var msgs = root.querySelectorAll('.kh-ann__msg');
    if (msgs.length < 2 || reduced) return;
    var i = 0, ms = (parseInt(root.dataset.speed, 10) || 5) * 1000, t;
    function go() { msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }
    function start() { stop(); t = setInterval(go, ms); }
    function stop() { clearInterval(t); }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    start();
  }

  function initDrawer(drawer) {
    if (drawer.dataset.khInit) return; drawer.dataset.khInit = '1';
    var accs = drawer.querySelectorAll('[data-kh-acc]');
    function setOpen(acc, open) {
      acc.classList.toggle('is-open', open);
      var tg = acc.querySelector('.kh-acc__toggle');
      if (tg) tg.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    accs.forEach(function (acc) {
      var tg = acc.querySelector('.kh-acc__toggle');
      if (!tg) return;
      function toggle() {
        var open = !acc.classList.contains('is-open');
        accs.forEach(function (o) { if (o !== acc) setOpen(o, false); });   /* tek seferde bir bölüm açık */
        setOpen(acc, open);
        if (open) setTimeout(function () { tg.scrollIntoView({ block: 'nearest', behavior: reduced ? 'auto' : 'smooth' }); }, 260);
      }
      tg.addEventListener('click', toggle);
      tg.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    });
    /* kapat: Dawn HeaderDrawer'ın kendi özetine tıklat ⇒ overflow, odak, menu-open temizliği Dawn'da kalır */
    var close = drawer.querySelector('[data-kh-drawer-close]');
    var details = drawer.closest('details');
    function doClose() {
      var s = details && details.querySelector(':scope > summary');
      if (s && details.hasAttribute('open')) s.click();
      setTimeout(function () { accs.forEach(function (o) { setOpen(o, false); }); }, 450);
    }
    if (close) {
      close.addEventListener('click', doClose);
      close.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); doClose(); } });
    }
    /* karartmaya tıklama: summary::before summary'nin parçası ⇒ Dawn zaten kapatır */
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-kh-rotator]').forEach(initRotator);
    scope.querySelectorAll('.kh-drawer').forEach(initDrawer);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* 09-18 (5) — mobil: kaydırınca arama kutusu büyütece dönüşür (Nook); ikona dokununca kutu açılır + odak */
(function () {
  'use strict';
  var header = document.querySelector('.kh-header');
  if (!header) return;
  var mq = window.matchMedia('(max-width: 989px)');
  var toggle = header.querySelector('[data-kh-search-toggle]');
  var input = header.querySelector('.kh-hsearch__input');
  var compact = false, ticking = false;
  function apply() {
    ticking = false;
    var y = window.scrollY || 0;
    var next = mq.matches && (compact ? y > 40 : y > 160);            /* histerezis: titremesin */
    if (next !== compact) {
      compact = next;
      header.classList.toggle('kh-compact', compact);
      if (!compact) header.classList.remove('kh-search-open');
    }
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(apply); } }, { passive: true });
  mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
  function open() {
    header.classList.add('kh-search-open');
    if (input) setTimeout(function () { input.focus(); }, 60);
  }
  if (toggle) {
    toggle.addEventListener('click', open);
    toggle.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
  }
  if (input) input.addEventListener('blur', function () {
    setTimeout(function () { if (!input.value && !header.contains(document.activeElement)) header.classList.remove('kh-search-open'); }, 200);
  });
  apply();
})();

/* 09-18 (6) → 09-19 — hızlı ekle: ürün kartı "+" (form[data-kh-qa]) ve çekmecedeki çapraz satış ([data-kh-ekle]).
   Sepet AÇILMAZ (Volkan 09-19): butonda tik çizilir, sepet sayısı güncellenip zıplar. Çekmece içeriği arkada tazelenir
   (açıksa — çapraz satış — yerinde yenilenir). Dawn renderContents() çekmeceyi açtığı için onun döngüsü elle, open() olmadan. */
(function () {
  'use strict';
  function tazele(cart, secs, res) {
    secs.forEach(function (s) {
      var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      var html = res.sections && res.sections[s.id];
      if (!el || !html) return;
      var src = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector || '.shopify-section');
      if (src) el.innerHTML = src.innerHTML;
    });
    if (cart) {
      cart.classList.remove('is-empty');
      var inner = cart.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty');
      var ov = cart.querySelector('#CartDrawer-Overlay'); if (ov && cart.close) ov.addEventListener('click', cart.close.bind(cart));
    }
    var b = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (b) { b.classList.remove('kh-pop'); void b.offsetWidth; b.classList.add('kh-pop'); }
  }
  function ekle(fd, btn) {
    if (!btn || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    var cart = document.querySelector('cart-drawer');
    var secs = cart && typeof cart.getSectionsToRender === 'function' ? cart.getSectionsToRender() : [{ id: 'cart-icon-bubble' }];
    fd.append('sections', secs.map(function (s) { return s.id; }).join(','));
    fd.append('sections_url', window.location.pathname);
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (res.status) { alert(res.description || res.message || 'Sepete eklenemedi'); return; }
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
        if (btn.matches('.product-form__submit, .kh-pd-sticky__btn')) eklendiYaz();
        tazele(cart, secs, res);
        document.dispatchEvent(new CustomEvent('kh:sepet-eklendi', { detail: res }));
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  }
  /* 09-30 — ürün sayfası "Sepete ekle" de sepeti AÇMAZ (Volkan): Dawn product-form yerine bu döngü; buton ~2,5 sn yeşil "✓ Eklendi".
     Yakalama evresinde (capture) dinlenir ki Dawn'ın form üstündeki submit dinleyicisine hiç ulaşmasın. */
  function eklendiYaz() {
    document.querySelectorAll('.product-form__submit, .kh-pd-sticky__btn').forEach(function (b) {
      var t = b.querySelector('span') || b;
      if (!b.classList.contains('kh-eklendi')) b.dataset.khYazi = t.textContent;
      t.textContent = '✓ Eklendi'; b.classList.add('kh-eklendi');
      clearTimeout(b._khT);
      b._khT = setTimeout(function () {
        b.classList.remove('kh-eklendi');
        if (t.textContent === '✓ Eklendi') t.textContent = b.dataset.khYazi;
      }, 2500);
    });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('product-form form[data-type="add-to-cart-form"]');
    if (!form || form.closest('quick-add-modal')) return;
    e.preventDefault(); e.stopPropagation();
    var btn = (e.submitter && e.submitter.matches('.kh-pd-sticky__btn')) ? e.submitter : form.querySelector('.product-form__submit');
    ekle(new FormData(form), btn);
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-kh-qa]');
    if (!form) return;
    e.preventDefault();
    ekle(new FormData(form), form.querySelector('.kh-uk__plus, button[type="submit"]'));
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-kh-ekle]');
    if (!btn) return;
    e.preventDefault();
    var fd = new FormData(); fd.append('id', btn.getAttribute('data-kh-ekle')); fd.append('quantity', '1');
    ekle(fd, btn);
  });
})();

/* 09-18 (7) — kart galerisi: kaydırınca çizgi + oklar güncellenir; oklar bir görsel kaydırır (belge düzeyinde: filtreyle gelen kartlar da çalışır) */
(function () {
  'use strict';
  function upd(track) {
    var card = track.closest('.kh-uk'); if (!card) return;
    var n = track.children.length, w = track.clientWidth || 1;
    var i = Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / w)));
    var bar = card.querySelector('.kh-uk__bar'); if (bar) bar.style.setProperty('--i', i);
    var prev = card.querySelector('[data-kh-uk-prev]'), next = card.querySelector('[data-kh-uk-next]');
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= n - 1;
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.nodeType === 1 && t.hasAttribute('data-kh-uk-track')) requestAnimationFrame(function () { upd(t); });
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kh-uk-prev],[data-kh-uk-next]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var tr = b.closest('.kh-uk__media').querySelector('[data-kh-uk-track]');
    tr.scrollBy({ left: (b.hasAttribute('data-kh-uk-next') ? 1 : -1) * tr.clientWidth, behavior: 'smooth' });
  });
})();

/* 09-19 — 720 · Video vitrini: aktif video ortada; oklar, noktalar, kaydırma (parmak/fare), yan videoya tıklayınca ona geç, ses düğmesi */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.khInit) return; root.dataset.khInit = '1';
    var track = root.querySelector('[data-kh-vv-track]'); if (!track) return;
    var vp = track.parentElement;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-kh-vv-slide]'));
    var dots = root.querySelectorAll('[data-kh-vv-dot]');
    var prev = root.querySelector('[data-kh-vv-prev]'), next = root.querySelector('[data-kh-vv-next]');
    var i = Math.min(parseInt(root.dataset.start, 10) || 0, slides.length - 1);
    /* 09-19: yalnız ORTADAKİ video oynar, diğerleri durur; bölüm ekran dışındayken o da durur (site hızı) */
    var visible = false;
    slides.forEach(function (el) { var v = el.querySelector('video'); if (v) { v.removeAttribute('autoplay'); v.pause(); } });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        var v = slides[i] && slides[i].querySelector('video');
        if (!v) return;
        if (visible) { var pl = v.play(); if (pl && pl.catch) pl.catch(function () {}); } else v.pause();
      }, { threshold: 0.25 }).observe(root);
    } else { visible = true; }
    function go(n) {
      i = Math.max(0, Math.min(slides.length - 1, n));
      var s = slides[i];
      var off = vp.clientWidth / 2 - (s.offsetLeft + s.offsetWidth / 2);
      track.style.transform = 'translateX(' + off + 'px)';
      slides.forEach(function (el, k) {
        el.classList.toggle('is-active', k === i);
        var v = el.querySelector('video');
        if (v) {
          if (k !== i) { v.pause(); v.muted = true; var sb = el.querySelector('[data-kh-vv-sound]'); if (sb) sb.classList.remove('is-on'); }
          else if (visible) { var pl = v.play(); if (pl && pl.catch) pl.catch(function () {}); }
        }
      });
      Array.prototype.forEach.call(dots, function (d, k) { d.classList.toggle('is-active', k === i); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    Array.prototype.forEach.call(dots, function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.khVvDot, 10)); }); });
    slides.forEach(function (el, k) {
      el.addEventListener('click', function (e) {
        if (k !== i) { e.preventDefault(); go(k); }
      }, true);
    });
    root.addEventListener('click', function (e) {
      var sb = e.target.closest('[data-kh-vv-sound]'); if (!sb) return;
      e.preventDefault(); e.stopPropagation();
      var v = sb.closest('.kh-vv__media').querySelector('video'); if (!v) return;
      v.muted = !v.muted; sb.classList.toggle('is-on', !v.muted);
      if (!v.muted) { var pl = v.play(); if (pl && pl.catch) pl.catch(function () {}); }
    });
    var x0 = null, y0 = null;
    vp.addEventListener('pointerdown', function (e) { x0 = e.clientX; y0 = e.clientY; }, { passive: true });
    vp.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0, dy = e.clientY - y0; x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(i + (dx < 0 ? 1 : -1));
    }, { passive: true });
    window.addEventListener('resize', function () { go(i); });
    go(i);
  }
  function all(scope) { (scope || document).querySelectorAll('[data-kh-vv]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();

/* 09-19 — 720 footer: mobilde link sütunları akordeon */
document.addEventListener('click', function (e) {
  var t = e.target.closest && e.target.closest('[data-kh-ft-toggle]');
  if (!t || window.matchMedia('(min-width: 750px)').matches) return;
  var col = t.closest('[data-kh-ft-col]'); var open = !col.classList.contains('is-open');
  col.classList.toggle('is-open', open); t.setAttribute('aria-expanded', open ? 'true' : 'false');
});
document.addEventListener('keydown', function (e) {
  var t = e.target.closest && e.target.closest('[data-kh-ft-toggle]');
  if (t && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); t.click(); }
});

/* 09-19 — ürün sayfası: mobil yapışkan "Sepete ekle" çubuğu, ana buton ekran dışındayken görünür */
(function () {
  'use strict';
  var bar = document.querySelector('[data-kh-pd-sticky]'); if (!bar) return;
  document.body.appendChild(bar);   /* Dawn reveal animasyonu (transform) fixed'i kutuya hapsediyordu */
  var main = document.querySelector('.product-form__submit'); if (!main) return;
  var shown = null, tick = false;
  function upd() {
    tick = false;
    var past = main.getBoundingClientRect().bottom < 0;   /* ana buton ekranın üstünden çıktı */
    if (past === shown) return; shown = past;
    bar.classList.toggle('is-shown', past); bar.setAttribute('aria-hidden', past ? 'false' : 'true');
    bar.querySelector('button').tabIndex = past ? 0 : -1;
  }
  window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
  upd();
})();

/* 09-19 → 09-28 — kolaj yazısı header'a yapışır: artık CSS sticky (.kh-kolaj__blok). JS yalnız header'ın alt kenarını
   --kh-hb'ye yazar, o da DEĞİŞİNCE (mobilde arama kutusu küçülünce vb.) — her karede stil basmak telefonda titretiyordu. */
(function () {
  'use strict';
  var son = -1, tick = false, root = document.documentElement;
  function upd() {
    tick = false;
    var h = document.querySelector('sticky-header, .header-wrapper');
    var b = h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 0;
    if (b !== son) { son = b; root.style.setProperty('--kh-hb', b + 'px'); }
  }
  function req() { if (!tick) { tick = true; requestAnimationFrame(upd); } }
  upd();
  window.addEventListener('scroll', req, { passive: true });
  window.addEventListener('resize', req);
  window.addEventListener('load', req);
})();

/* 09-19 — 720 · Kayan ürünler (Nook parallax): ürün görseli ekrana girdiği andan itibaren sayfadan (hız − 1) kat daha hızlı
   yukarı kayar ve dönüşümlü yönde en fazla "dönüş" derece döner (Nook: tek/çift −/+). Ölçüm dönüşümsüz <li>'den. */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.CSS && CSS.supports && CSS.supports('animation-timeline: view()')) return;   /* 09-28: CSS scroll animasyonu yürütüyor */
  if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;             /* 09-28 (2): dokunmatikte hareket yok (titreme) */
  var secs = [], tick = false;
  function collect() {
    secs = Array.prototype.slice.call(document.querySelectorAll('[data-kh-kayan]')).map(function (el) {
      return {
        el: el, hiz: parseFloat(el.getAttribute('data-hiz')) || 1, donus: parseFloat(el.getAttribute('data-donus')) || 0,
        items: Array.prototype.slice.call(el.querySelectorAll('.kh-kayan__oge')).map(function (li, i) {
          return { li: li, img: li.querySelector('.kh-kayan__img'), yon: i % 2 === 0 ? -1 : 1 };
        })
      };
    });
  }
  function upd() {
    tick = false;
    var vh = window.innerHeight;
    secs.forEach(function (o) {
      var r = o.el.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) return;
      o.items.forEach(function (it) {
        if (!it.img) return;
        var girdi = Math.max(0, vh - it.li.getBoundingClientRect().top);
        var ty = -(o.hiz - 1) * girdi, rot = Math.min(girdi / vh, 1) * o.donus * it.yon;
        it.img.style.transform = 'translate3d(0,' + ty.toFixed(1) + 'px,0) rotate(' + rot.toFixed(2) + 'deg)';
      });
    });
  }
  function req() { if (!tick) { tick = true; requestAnimationFrame(upd); } }
  collect(); upd();
  window.addEventListener('scroll', req, { passive: true });
  window.addEventListener('resize', req);
  document.addEventListener('shopify:section:load', function () { collect(); req(); });
})();

/* 09-19 — kategori vitrini kare döngüsü (GIF gibi): [data-kh-dongu] içindeki .kh-dep__kare'ler sırayla görünür (varsayılan 400 ms).
   Yalnız ekrandayken döner; hareket azaltma tercihinde ilk karede durur. */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function bagla(root) {
    root.querySelectorAll('[data-kh-dongu]').forEach(function (el) {
      if (el.__khD) return; el.__khD = true;
      var k = el.querySelectorAll('.kh-dep__kare'), i = 0, t = null, ms = parseInt(el.getAttribute('data-kh-dongu'), 10) || 400;
      if (k.length < 2) return;
      function adim() { k[i].classList.remove('is-on'); i = (i + 1) % k.length; k[i].classList.add('is-on'); }
      function bas() { if (!t) t = setInterval(adim, ms); }
      function dur() { clearInterval(t); t = null; }
      if (!('IntersectionObserver' in window)) return bas();
      new IntersectionObserver(function (es) { es[0].isIntersecting ? bas() : dur(); }).observe(el);
    });
  }
  bagla(document);
  document.addEventListener('shopify:section:load', function (e) { bagla(e.target); });
})();

/* 09-28 — ürün ızgarası sayfalama (1-2-3): [data-kh-ug-sayfa] içindeki sayfa linkleri sayfayı yenilemeden bölümü değiştirir
   (Section Rendering API: ?page=N&sections=<id>), adres çubuğu ?page=N olur, bölüm başına kayar. JS yoksa normal link çalışır. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-kh-ug-sayfa] .pagination a[href]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var kok = a.closest('[data-kh-ug-sayfa]'), id = kok.getAttribute('data-kh-ug-sayfa');
    var u = new URL(a.href, location.href); u.hash = '';
    var istek = new URL(u); istek.searchParams.set('sections', id);
    e.preventDefault();
    kok.classList.add('is-yukleniyor');
    fetch(istek.toString(), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var yeni = new DOMParser().parseFromString(j[id] || '', 'text/html').querySelector('[data-kh-ug-sayfa]');
      if (!yeni) { location.href = a.href; return; }
      kok.replaceWith(yeni);
      history.pushState({}, '', u.pathname + u.search);
      var hb = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--kh-hb')) || 0;
      window.scrollTo({ top: yeni.getBoundingClientRect().top + window.scrollY - hb - 8, behavior: 'smooth' });
    }).catch(function () { location.href = a.href; });
  });
  window.addEventListener('popstate', function () { if (document.querySelector('[data-kh-ug-sayfa]')) location.reload(); });
})();

/* 09-28 — dekor videoları (hero): otomatik oynatma engellenirse (iOS düşük güç modu vb.) ilk dokunuşta / görünür olunca sessizce yeniden dene. */
(function () {
  'use strict';
  var vids = Array.prototype.slice.call(document.querySelectorAll('video.kh-bn__video'));
  if (!vids.length) return;
  function oynat() { vids.forEach(function (v) { if (v.paused) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } }); }
  oynat();
  ['touchstart', 'scroll', 'visibilitychange'].forEach(function (e) { window.addEventListener(e, oynat, { passive: true, once: e !== 'visibilitychange' }); });
})();

